<div class="position-relative">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-title"> {{ errorCodeEdit ? 'Edit' : errorCodeView ? 'View' :
        'Add' }}
        Error Code</div>
    <!-- <ngx-loading [show]="loading"></ngx-loading> -->

    <form [formGroup]="errorCodeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="make-responsive">
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Error Code</mat-label>
                    <input matInput formControlName="errorCode">
                    <ng-container *ngIf="formSubmitted && formValues['errorCode'].errors">
                        <mat-error *ngIf="formValues['errorCode'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Name is required
                        </mat-error>
                        <mat-error *ngIf="formValues['errorCode'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                            </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="modal-form d-flex -text-area-field-height">
                <mat-form-field>
                    <mat-label>Description</mat-label>
                    <textarea matInput cdkTextareaAutosize formControlName="description" #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
                        <ng-container *ngIf="formSubmitted && formValues['description'].errors">
                            <mat-error *ngIf="formValues['description'].errors?.['required']">
                                <em class="fas fa-exclamation-circle mr-2"></em>Description is required
                            </mat-error>
                            <mat-error *ngIf="formValues['description'].errors?.['pattern']">
                                <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                                </mat-error>
                        </ng-container>
                </mat-form-field>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
                    class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
        </div>
        <div class="btn-basket">
            <button mat-raised-button color="primary" data-dismiss="modal" type="button"
                (click)="closeModal()">Close</button>
            <button *ngIf="!errorCodeView" mat-raised-button color="primary" type="submit">
                {{ errorCodeEdit ? 'Update' : 'Submit' }}
            </button>
        </div>
    </form>
</div>